import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-black border-t border-white/10 pt-20 pb-10" data-id="element-239">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-240">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-241">
          {/* Company Info */}
          <div className="flex flex-col gap-6" data-id="element-242">
            <Link to="/" className="flex items-center gap-2" data-id="element-243">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/9fea8157-abe6-4116-8e53-72149f139631.png" alt="Design Flow Digitals" className="w-10 h-10 object-contain" data-id="element-244" />
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-245">
                Design Flow Digitals
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-246">
              Premium Shopify development company specializing in themes, apps
              and high-converting ecommerce stores.
            </p>
            <div className="text-sm text-gray-500" data-id="element-247">
              <p data-id="element-248">Part of Pankaj Maurya LLC</p>
              <p data-id="element-249">67 Wigley Loop</p>
              <p data-id="element-250">Whitwell, TN 37397</p>
              <p data-id="element-251">United States</p>
            </div>
            <a href="mailto:support@designflowdigitals.com" className="text-gradient-gold font-medium text-sm hover:opacity-80 transition-opacity" data-id="element-252">
              support@designflowdigitals.com
            </a>
          </div>

          {/* Company Links */}
          <div data-id="element-253">
            <h3 className="text-white font-semibold mb-6" data-id="element-254">Company</h3>
            <ul className="flex flex-col gap-4" data-id="element-255">
              <li data-id="element-256">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-257">
                  About Us
                </Link>
              </li>
              <li data-id="element-258">
                <Link to="/team" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-259">
                  Meet the Team
                </Link>
              </li>
              <li data-id="element-260">
                <Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-261">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-262">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-263">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div data-id="element-264">
            <h3 className="text-white font-semibold mb-6" data-id="element-265">Products</h3>
            <ul className="flex flex-col gap-4" data-id="element-266">
              <li data-id="element-267">
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-268">
                  All Products
                </Link>
              </li>
              <li data-id="element-269">
                <Link to="/themes" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-270">
                  Shopify Themes
                </Link>
              </li>
              <li data-id="element-271">
                <Link to="/apps" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-272">
                  Shopify Apps
                </Link>
              </li>
              <li data-id="element-273">
                <Link to="/ai-photoshoot" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-274">
                  AI Photoshoot App
                </Link>
              </li>
              <li data-id="element-275">
                <Link to="/flowboost" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-276">
                  FlowBoost App
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-277">
            <h3 className="text-white font-semibold mb-6" data-id="element-278">Services</h3>
            <ul className="flex flex-col gap-4" data-id="element-279">
              <li data-id="element-280">
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-281">
                  Store Development
                </Link>
              </li>
              <li data-id="element-282">
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-283">
                  Theme Development
                </Link>
              </li>
              <li data-id="element-284">
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-285">
                  App Development
                </Link>
              </li>
              <li data-id="element-286">
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-287">
                  Conversion Optimization
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-288">
          <p className="text-gray-500 text-sm" data-id="element-289">
            &copy; {currentYear} Design Flow Digitals. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-290">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-291">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-292">
              Terms of Service
            </Link>
            <Link to="/refund-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-293">
              Refund Policy
            </Link>
            <Link to="/cookies-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-294">
              Cookies Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}